import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'

import { init as sentryInit } from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import Notifications from 'vue-notification'
import VModal from 'vue-js-modal'
import { VTooltip, VPopover } from 'v-tooltip'

import './plugins/veeValidate.js'
import i18nWrapper from './plugins/i18n'
import storeWrapper from './store/'
import routerWrapper from './router'
import App from './App'
import Button from './components/Button'
import Icon from './components/Icon'
import Loading from './components/Loading'

import { SENTRY_DSN, SENTRY_ENV, SENTRY_RELEASE } from '@/config.js'

Vue.config.productionTip = false

const i18n = i18nWrapper.createFor(Vue)
const store = storeWrapper.createFor(Vue)
const router = routerWrapper.createFor(Vue, store)

Vue.use(Notifications)
Vue.use(VModal, { componentName: 'Modal' })

sentryInit({
  Vue,
  dsn: SENTRY_DSN,
  logErrors: true,
  environment: SENTRY_ENV,
  release: SENTRY_RELEASE,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.5,
  tracingOptions: {
    trackComponents: true,
  },
})

Vue.directive('tooltip', VTooltip)
Vue.component('v-popover', VPopover)

Vue.component('btn', Button)
Vue.component('Icon', Icon)
Vue.component('Loading', Loading)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
